/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Retainer_Updates_Desc7Inputs */

const en_svc_retainer_updates_desc7 = /** @type {(inputs: Svc_Retainer_Updates_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Patches applied and verified monthly, breaking changes flagged early.`)
};

const ar_svc_retainer_updates_desc7 = /** @type {(inputs: Svc_Retainer_Updates_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الترقيعات تطبق وتتحقق شهريا، والتغييرات الكاسرة تبلغ مبكرا.`)
};

const bn_svc_retainer_updates_desc7 = /** @type {(inputs: Svc_Retainer_Updates_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`প্যাচ মাসে প্রয়োগ আর যাচাই করা, ভাঙা পরিবর্তন আগেই জানানো।`)
};

const de_svc_retainer_updates_desc7 = /** @type {(inputs: Svc_Retainer_Updates_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Patches monatlich angewendet und verifiziert, Breaking Changes früh gemeldet.`)
};

const es_svc_retainer_updates_desc7 = /** @type {(inputs: Svc_Retainer_Updates_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parches aplicados y verificados cada mes, cambios rotos avisados pronto.`)
};

const fr_svc_retainer_updates_desc7 = /** @type {(inputs: Svc_Retainer_Updates_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Correctifs appliqués et vérifiés chaque mois, changements cassants signalés tôt.`)
};

const pt_svc_retainer_updates_desc7 = /** @type {(inputs: Svc_Retainer_Updates_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Patches aplicados e verificados todos os meses, mudanças que quebram avisadas cedo.`)
};

const zh_svc_retainer_updates_desc7 = /** @type {(inputs: Svc_Retainer_Updates_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`补丁每月打每月验，不兼容变更提前预警。`)
};

const tr_svc_retainer_updates_desc7 = /** @type {(inputs: Svc_Retainer_Updates_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yamalar aylık uygulanır, doğrulanır, kıran değişiklikler erken bildirilir.`)
};

const ru_svc_retainer_updates_desc7 = /** @type {(inputs: Svc_Retainer_Updates_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Патчи ставятся и проверяются ежемесячно, ломающие изменения видны рано.`)
};

const pl_svc_retainer_updates_desc7 = /** @type {(inputs: Svc_Retainer_Updates_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Patche stosowane i weryfikowane co miesiąc, łamiące zmiany sygnalizowane wcześnie.`)
};

/**
* | output |
* | --- |
* | "Patches applied and verified monthly, breaking changes flagged early." |
*
* @param {Svc_Retainer_Updates_Desc7Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_retainer_updates_desc7 = /** @type {((inputs?: Svc_Retainer_Updates_Desc7Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Retainer_Updates_Desc7Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_retainer_updates_desc7(inputs)
	if (locale === "bn") return bn_svc_retainer_updates_desc7(inputs)
	if (locale === "de") return de_svc_retainer_updates_desc7(inputs)
	if (locale === "es") return es_svc_retainer_updates_desc7(inputs)
	if (locale === "fr") return fr_svc_retainer_updates_desc7(inputs)
	if (locale === "pt") return pt_svc_retainer_updates_desc7(inputs)
	if (locale === "zh") return zh_svc_retainer_updates_desc7(inputs)
	if (locale === "tr") return tr_svc_retainer_updates_desc7(inputs)
	if (locale === "ru") return ru_svc_retainer_updates_desc7(inputs)
	if (locale === "pl") return pl_svc_retainer_updates_desc7(inputs)
	return en_svc_retainer_updates_desc7(inputs)
});
export { svc_retainer_updates_desc7 as "svc_retainer_UPDATES_desc" }